export default {
  global: {
    font: { family: "Helvetica Neue", size: "14px", height: "20px" },
    colors: { background: "#ffffff", text: "#0b0c0c" }
  },
  heading: { font: { size: "48px" } },
  graph: {
    colors: [
      "#005ea5",
      "rgba(177, 14, 30, 0.2)",
      "rgba(177, 14, 30, 0.4)",
      "rgba(177, 14, 30, 0.6)",
      "rgba(177, 14, 30, 0.8)",
      "rgba(177, 14, 30, 1)"
    ]
  },
  rangeInput: {
    thumb: {
      color: "#005ea5"
    }
  }
}
